module.exports = __webpack_public_path__ + "img/research-group-5.229912ab.jpg";